import { render, staticRenderFns } from "./eventTypeRecipients.vue?vue&type=template&id=634171ee&"
import script from "./eventTypeRecipients.vue?vue&type=script&lang=js&"
export * from "./eventTypeRecipients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports